// extracted by mini-css-extract-plugin
module.exports = {"viewMore":"styles_viewMore__yaFXZ","subValues":"styles_subValues__dpXUw","visible":"styles_visible__fZVAi","subValue":"styles_subValue__1HIP1"};